export const UPDATE_STAND_DATA = 'STAND/UPDATE_STAND_DATA'

export const STAND_URL = "/bus/:stand-bus-stand/"
